import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import api from "@/lib/api";
import StatusBadge from "@/components/StatusBadge";
import { Link } from "react-router-dom";

export default function UnderwriterDashboard() {
  const [m, setM] = useState(null);
  const [queue, setQueue] = useState([]);
  const navigate = useNavigate();
  useEffect(() => {
    api.get("/dashboard/underwriter").then(r => setM(r.data));
    api.get("/applications", { params: { status: "Underwriting Pending" } }).then(r => setQueue(r.data));
  }, []);
  return (
    <div data-testid="underwriter-dashboard">
      <h1 className="text-2xl font-semibold text-slate-900 mb-1">Underwriter Queue</h1>
      <p className="text-sm text-slate-600 mb-6">Decision applications with CarDr-adjusted valuations and credit policy.</p>
      <div className="grid grid-cols-2 md:grid-cols-5 gap-4">
        <Kpi label="New cases" value={m?.new_cases} testId="uw-kpi-new" />
        <Kpi label="Manual review" value={m?.manual_review} testId="uw-kpi-manual" />
        <Kpi label="Approved" value={m?.approved} testId="uw-kpi-approved" />
        <Kpi label="Rejected" value={m?.rejected} testId="uw-kpi-rejected" />
        <Kpi label="High repair" value={m?.high_repair_exposure} testId="uw-kpi-high-repair" />
      </div>

      <Card className="mt-6 border-slate-200 overflow-hidden">
        <div className="px-5 py-3 border-b border-slate-100 font-semibold text-slate-900 text-sm">New cases in queue</div>
        <table className="w-full text-sm">
          <thead className="bg-slate-50 text-slate-500 text-xs uppercase tracking-wider">
            <tr><th className="text-left px-4 py-3">App ID</th><th className="text-left px-4 py-3">Borrower</th><th className="text-left px-4 py-3">Vehicle</th><th className="text-left px-4 py-3">Grade</th><th className="text-left px-4 py-3">Status</th></tr>
          </thead>
          <tbody>
            {queue.length === 0 ? (
              <tr><td colSpan={5} className="p-6 text-center text-slate-500">No applications in queue.</td></tr>
            ) : queue.map(a => (
              <tr key={a.id} className="border-t border-slate-100 hover:bg-slate-50">
                <td className="px-4 py-3"><Link to={`/underwriter/applications/${a.id}`} className="font-mono text-teal-700 font-medium" data-testid={`uw-queue-link-${a.application_id}`}>{a.application_id}</Link></td>
                <td className="px-4 py-3">{a.borrower?.full_name}</td>
                <td className="px-4 py-3">{a.vehicle?.make} {a.vehicle?.model}</td>
                <td className="px-4 py-3 font-mono">{a.cardr?.health_grade || "—"}</td>
                <td className="px-4 py-3"><StatusBadge status={a.status} /></td>
              </tr>
            ))}
          </tbody>
        </table>
      </Card>
    </div>
  );
}

function Kpi({ label, value, testId }) {
  return (
    <Card className="p-5 border-slate-200" data-testid={testId}>
      <div className="text-xs uppercase tracking-wider text-slate-500">{label}</div>
      <div className="text-3xl font-semibold text-slate-900 mt-1 font-mono">{value ?? "—"}</div>
    </Card>
  );
}
